import { render, staticRenderFns } from "./Loodsopname.vue?vue&type=template&id=6660fe36&"
import script from "./Loodsopname.vue?vue&type=script&lang=js&"
export * from "./Loodsopname.vue?vue&type=script&lang=js&"
import style0 from "./Loodsopname.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Loodsopname.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports